module.exports = __webpack_public_path__ + "static/media/adv-img1.a7e4b42a.jpg";